import { ICountry } from '../interface';

// Country helpers. In the old project these live OUTSIDE the SettingsContext
// (the context value is the settings object itself); callers pass the country
// list from `settings.countries`.

export const getCountry = (countries: ICountry[], id: number | string | null): ICountry | null => {
  if (id === null || id === undefined) return null;
  return countries.find((country) => country.id.toString() === id.toString()) ?? null;
};

export const getCountryId = (countries: ICountry[], abbr: string): number | null => {
  return countries.find((country) => country.abbr === abbr)?.id ?? null;
};

export const getCountryCode = (countries: ICountry[], id: number | string | null): string => {
  if (id === null || id === undefined) return '';
  return countries.find((country) => country.id.toString() === id.toString())?.abbr ?? '';
};
